import { render, staticRenderFns } from "./EnshrineSettingTab.vue?vue&type=template&id=4c25f62c&scoped=true&"
import script from "./EnshrineSettingTab.vue?vue&type=script&lang=js&"
export * from "./EnshrineSettingTab.vue?vue&type=script&lang=js&"
import style0 from "./EnshrineSettingTab.vue?vue&type=style&index=0&id=4c25f62c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c25f62c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c25f62c')) {
      api.createRecord('4c25f62c', component.options)
    } else {
      api.reload('4c25f62c', component.options)
    }
    module.hot.accept("./EnshrineSettingTab.vue?vue&type=template&id=4c25f62c&scoped=true&", function () {
      api.rerender('4c25f62c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/god/comp/EnshrineSettingTab.vue"
export default component.exports